import { createContext, useContext, useMemo, type ReactNode } from 'react';

import { createChartHoverSync, type ChartHoverSync } from './chartHoverSync';

interface ChartSyncContextValue {
  sync: ChartHoverSync;
}

const ChartSyncContext = createContext<ChartSyncContextValue | null>(null);

export interface ChartSyncProviderProps {
  children: ReactNode;
}

export function ChartSyncProvider({ children }: ChartSyncProviderProps) {
  const sync = useMemo(() => createChartHoverSync(), []);

  const value = useMemo(() => ({ sync }), [sync]);

  return <ChartSyncContext.Provider value={value}>{children}</ChartSyncContext.Provider>;
}

export function useChartSync(): ChartSyncContextValue | null {
  return useContext(ChartSyncContext);
}
